import { useAuthContext } from "providers/Auth";
import { useUnitsPropertiesDictionary } from "shared/hooks/use-units-properties";

export const useEditDetailsPermissions = () => {
  const { permissions } = useAuthContext();
  const { property, unit } = useUnitsPropertiesDictionary();

  const canEditPropertyDetails = permissions.canEditPropertyDetails;
  const canEditUnitDetails = permissions.canEditUnitDetails;

  return {
    canEditPropertyDetails,
    canEditUnitDetails,
    propertyEditDeniedTooltip: canEditPropertyDetails
      ? undefined
      : `You don't have permission to edit ${property} details`,
    unitEditDeniedTooltip: canEditUnitDetails
      ? undefined
      : `You don't have permission to edit ${unit} details`,
    unitDeleteDeniedTooltip: canEditUnitDetails
      ? undefined
      : `You don't have permission to delete the ${unit}`
  };
};
